import { ArrayMinSize, IsArray, IsEnum, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { DayOfWeek } from './day-of-week.enum';

export class UpdateCleaningAreaDto {
  @IsString()
  @IsNotEmpty()
  @IsOptional()
  name?: string;

  @IsString()
  @IsNotEmpty()
  @IsOptional()
  icon?: string;

  // null clears the field: the backend ignores undefined keys on PUT.
  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  description?: string | null;

  @IsArray()
  @ArrayMinSize(1)
  @IsEnum(DayOfWeek, { each: true })
  @IsOptional()
  scheduledDays?: DayOfWeek[];

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  products?: string | null;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  procedure?: string | null;
}
